import { Text } from "@/components/text/text.component";

export const ComparePlanTableFootnotes = ({
  footnotes,
}: ComparePlanTableFootnotesProps) => {
  const items = footnotes.filter(Boolean);
  if (!items.length) return null;

  return (
    <ul
      className="mx-5 mt-6 list-none space-y-1 md:mx-0"
      data-testid="compare-plan-table-footnotes">
      {items.map((footnote, index) => (
        <li key={`footnote-${index}`}>
          <Text variant="legal" component="p">
            {footnote}
          </Text>
        </li>
      ))}
    </ul>
  );
};

type ComparePlanTableFootnotesProps = {
  footnotes: Array<string | null>;
};
